import {i18n} from 'src/shared/config'

/**
 * Размер посылки для внешней формы
 */
export const enum OrderParcelSize {
  ExtraSmall = 'extraSmall',
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  ExtraLarge = 'extraLarge',
  ExtraExtraLarge = 'extraExtraLarge',
}

type Translations = {
  title: string
  weightTitle?: string
  subtitle?: string
}

const PARCEL_SIZE_ORDER_TRANSLATION_MAPPING: Readonly<Record<OrderParcelSize, Translations>> = {
  [OrderParcelSize.ExtraSmall]: {
    title: i18n('form.ndd.parcel.xs.title', 'Конверт'),
    subtitle: i18n('form.ndd.parcel.xs.subtitle', 'Размер А4'),
    weightTitle: i18n('form.ndd.parcel.xs.weight-title', 'До 0,5 кг'),
  },
  [OrderParcelSize.Small]: {
    title: i18n('form.ndd.parcel.s.title', 'S'),
    subtitle: i18n('form.ndd.parcel.s.subtitle', '25×10×15 см'),
    weightTitle: i18n('form.ndd.parcel.s.weight-title', 'до 2 кг'),
  },
  [OrderParcelSize.Medium]: {
    title: i18n('form.ndd.parcel.m.title', 'M'),
    subtitle: i18n('form.ndd.parcel.m.subtitle', '35×15×25 см'),
    weightTitle: i18n('form.ndd.parcel.m.weight-title', 'до 5 кг'),
  },
  [OrderParcelSize.Large]: {
    title: i18n('form.ndd.parcel.l.title', 'L'),
    subtitle: i18n('form.ndd.parcel.l.subtitle', '45×30×20 см'),
    weightTitle: i18n('form.ndd.parcel.l.weight-title', 'до 12 кг'),
  },
  [OrderParcelSize.ExtraLarge]: {
    title: i18n('form.ndd.parcel.xl.title', 'XL'),
    subtitle: i18n('form.ndd.parcel.xl.subtitle', '60×40×45 см'),
    weightTitle: i18n('form.ndd.parcel.xl.weight-title', 'до 20 кг'),
  },
  [OrderParcelSize.ExtraExtraLarge]: {
    title: i18n('form.ndd.parcel.xxl.title', 'XXL'),
    subtitle: i18n('form.ndd.parcel.xxl.subtitle', '149×24×24 см'),
    weightTitle: i18n('form.ndd.parcel.xxl.weight-title', 'до 20 кг'),
  },
}

export const parcelEntries = Object.entries(PARCEL_SIZE_ORDER_TRANSLATION_MAPPING) as unknown as Array<
  [OrderParcelSize, Translations]
>

/**
 * Типы размеров посылок, которые относятся к бизнес-тарифу
 */
export const BUSINESS_PARCEL_SIZES: Readonly<Array<string>> = [OrderParcelSize.ExtraExtraLarge]
